import {css} from '@emotion/css';
import {Breakpoints, mq} from '../../../styles/js/mixins';
import {spacing, colours} from '../../../styles/js/variables';

const styles = {
  titleWrap: css`
    label: linkColumnsWithTitle__titleWrap;
    margin-bottom: ${spacing.S};
  `,
  title: css`
    label: linkColumnsWithTitle__title;
    line-height: 1.16;
  `,
  linksWrap: css`
    label: linkColumnsWithTitle__linksWrap;
    ${mq(Breakpoints.TABLET)} {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: ${spacing.XS};
      justify-content: space-between;
    }
    ${mq(Breakpoints.DESKTOP)} {
      grid-template-columns: repeat(3, 1fr);
    }
  `,
  link: css`
    label: linkColumnsWithTitle__link;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 1.2rem 1.5rem; // stylelint-disable-line sh-waqar/declaration-use-variable
    border: 1px solid ${colours.border.GRAY};
    width: 100%;
    height: auto;
    vertical-align: middle;
    margin-bottom: ${spacing.XS};
    text-decoration: none;
    background-color: ${colours.general.WHITE};
    color: ${colours.font.BLACK};

    &:hover {
      border-color: ${colours.semantic.DEFAULT_HOVER};
    }
    ${mq(Breakpoints.TABLET)} {
      margin-bottom: 0;
    }
  `,
};

export default styles;
